module.exports = __webpack_public_path__ + "img/16d001-18.c343c6a2.png";